import createIconsObj from 'common/src/assets/icons/utils/createIconsObj';

const icons = createIconsObj(
  {
    sendArrow: '/mask-icon-shaped-send-arrow.svg',
    magnet: '/mask-icon-magnet.svg',
    playback: '/mask-icon-playback.svg',
    settings: '/mask-icon-settings-0.svg',
    trash: '/mask-icon-trashcan-0.svg',
    download: '/mask-icon-download-0.svg',
    close: '/mask-icon-close-0.svg',
    editArticles: '/mask-icon-edit-articles.svg',
    plus: '/mask-icon-plus.svg',
    upload: '/mask-icon-upload.svg',
    attachment: '/mask-icon-attachment.svg',
    x: '/mask-icon-x.svg',
    xlsAttachment: '/mask-icon-xls-file.svg',
    questionMark: '/mask-icon-question-mark.svg',
    stars: '/icon-stars.svg',
  },
  'copilot',
);

export default icons;
